import React from "react";
import * as msal from "@azure/msal-browser";

import {
	APP_MSAL_SETUP
	,APP_AUTHENTICATE
	,APP_AVATAR
} from "./authTypes";

import { pageLoadFromDBAction } from "../page/pageActions";

import { axiosBaseURL } from '../../config/config';

import axios from "axios";

export function authInitialize(config) {
	return async (dispatch) => {
		const siteURL = window.location.href;

		// ************************************************************************************************************
		// NOTE: For password reset policy...
		// https://docs.microsoft.com/en-us/azure/active-directory-b2c/active-directory-b2c-devquickstarts-graph-dotnet
		// ************************************************************************************************************

		// ************************************************************************************************************
		// MSAL v1 to v2
		// https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/v1-migration.md
		// ************************************************************************************************************

		const clientApplication = new msal.PublicClientApplication({
			auth: {
				clientId: config.authentication.clientID,
				authority: config.authentication.authority,
				redirectUri: window.location.origin + axiosBaseURL()
			},
			cache: {
				cacheLocation: 'localStorage', // enable this for IE, as sessionStorage does not work for localhost.
				storeAuthStateInCookie: true
			}
		});

		let username = "";
		let email = "";

		// https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/initialization.md#redirect-apis
		await clientApplication.handleRedirectPromise()
			.then(handleResponse)
			.catch(error => {
				console.log('**ERROR**', error);
		});

		function handleResponse(resp) {
			if (resp !== null) {
				// If the tokenResponse !== null, then you are coming back from a successful authentication redirect.

				//console.log(resp);
				username = resp.account.name;
				email = resp.account.username;

				dispatch(authLoginComplete(clientApplication, username, email, null));
			} else {
				// If the tokenResponse === null, you are not coming back from an auth redirect but probably a refresh.

				// console.log(resp);
				const currentAccounts = clientApplication.getAllAccounts();

				if (!currentAccounts || currentAccounts.length === 0) {
					// No user signed in
					// console.log('no user signed in');
					clientApplication.loginRedirect(config.authentication.scopes);
				} else if (currentAccounts.length > 1) {
					// More than one user signed in, find desired user with getAccountByUsername(username)
					// Add choose account code here
					const currentAcc = clientApplication.getAccountByUsername(currentAccounts[0].username);
					// console.log(currentAcc);
					// console.log('Add choose account code here');
					dispatch(authLoginComplete(clientApplication, currentAcc.name, currentAcc.username, null));
				} else if (currentAccounts.length === 1) {
					const currentAcc = clientApplication.getAccountByUsername(currentAccounts[0].username);
					// console.log(currentAcc);
					// accountObj = currentAccounts[0];
					dispatch(authLoginComplete(clientApplication, currentAcc.name, currentAcc.username, null));
				}
			}
		}

		// Store Client Application / Setup for Login
		dispatch(authSaveMSALState(clientApplication, true, null));

	};
}

export function authLogin() {
	return (dispatch, getState) => {
		const state = getState();
		const auth = state.auth;
		const config = state.config.data;

		const clientApplication = auth.clientApplication;
		clientApplication.loginRedirect(config.authentication.scopes);
	};
}

// Store user and kick off Authentication
// export function authLoginComplete(clientApplication, token, objectID, username, email, error) {
export function authLoginComplete(clientApplication, username, email, error) {
	return (dispatch) => {
		dispatch({
			type: APP_AUTHENTICATE,
			payload: {
				clientApplication: clientApplication,
				initialized: true,
				authenticated: true,
				authenticating: false,
				username: username,
				email: email,
				error: error
			}
		});

		// Load up previously saved Pages
		dispatch(pageLoadFromDBAction());

		// Fetch the Avatar
		dispatch(authGetAvatar());
	};
}

export function authLogout() {
	return (dispatch, getState) => {
		const state = getState();

		const auth = state.auth;
		const clientApplication = auth.clientApplication;

		const logoutRequest = {
			account: clientApplication.getAccountByUsername(auth.username)
		}
		clientApplication.logout(logoutRequest);
		dispatch({
				type: APP_AUTHENTICATE,
				payload: {clientApplication: null, initialized: false, authenticated: false, authenticating: false, token: null, username: null, error: null, avatar: null}
			});
		sessionStorage.clear();
	};
}

export function authGetAvatar() {
	return (dispatch, getState) => {
		const state = getState();
		const auth = state.auth;
		const config = state.config;

		if (auth.authenticated){

			// Here we pass a date time stamp to ensure the latest config is always loaded
			axios
				.get(config.data.avatar.apiAvatar, {
					responseType: 'blob'
				})
				.then(function (response) {
					const url = window.webkitURL;
					const blobUrl = url.createObjectURL(response.data);

					dispatch({
						type: APP_AVATAR,
						payload: { avatar: blobUrl }
					});
				})
				.catch(function (error) {
					console.log('**ERROR**', error);

					// NOTE: We do not set to null bc the App.js doesn't
					// release the application until we have an Avatar
					// to avoid flicker
					dispatch({
						type: APP_AVATAR,
						payload: { avatar: -2112 }
					});
				});
		}
	}
}

// Initialize MSAL on startup
export function authSaveMSALState(clientApplication, authenticating, error) {
	return (dispatch) => {
		dispatch({
			type: APP_MSAL_SETUP,
			payload: { clientApplication: clientApplication, authenticating: authenticating, error: error }
		});
	};
}